// import { store } from '../..';
// import { logout } from '../../store/actions/authAction';
import { centeredNotification } from '../../utils/utility';
import { ShowErrorInInterceptor } from '../models/sendRequest.model';

export const errorHandler = (
  error: any,
  isShowErrorInInterceptor: boolean | ShowErrorInInterceptor,
  files?: File | File[],
  isBenef?: boolean,
  isBadRequest?: boolean,

): void => {
  if (error?.response ===  undefined ) {
    error.message = 'Please check your internet connection and try again.';
  }
  if (error?.response?.status === 403 || error?.response?.status === 401) {
    window.location.replace('/logout');
  } else {
    if (isBenef || isBadRequest) { // to prevent page reload
      error.response = 'Bad Gateway';
    } else {
      window.location.replace('/');
    }
  }
  if (isShowErrorInInterceptor) {
    let fileName = '';
    if (files && !files['length']) {
      fileName = files['name'] + ' : ';
    }
    centeredNotification(fileName + error.message);
  }
  // throw (error);
};
